import React, { useEffect } from 'react';
import styled from 'styled-components';
import { LayoutColors } from '@src/core/theme';
import { BodyLargeMedium, BodyRegularMedium, BodyRegularSemiBold } from '@src/fonts/typography/Typography';
import useTranslate from '@src/i18n/useTranslate';
import CheckSuccessIcon from '@src/icons/check-success.svg';
import { changeLocation } from '@src/core/store';
import { useAppDispatch, useWidgetParam } from '@src/core/hooks';
import { device } from '@src/common/breakpoints';
import { track } from '@src/services/analytics';

export const SuccessfulPayment = () => {
  const dispatch = useAppDispatch();
  const { i18n } = useTranslate();
  const checkoutRedirectTo = useWidgetParam('checkout-redirect-to');
  const checkoutRedirectButtonText = useWidgetParam('checkout-redirect-button-text');

  useEffect(() => {
    track('checkoutSuccessStepAccess');
  }, []);

  return (
    <Container>
      <Content>
        <Description>
          <CheckSuccessIcon />
          <span>{i18n('checkout_payment_successful')}</span>
        </Description>
        {checkoutRedirectTo ? (
          <Button onClick={() => dispatch(changeLocation(checkoutRedirectTo))}>
            {checkoutRedirectButtonText ?? i18n('checkout_payment_successful_redirect')}
          </Button>
        ) : null}
      </Content>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  max-width: 630px;
  height: 188px;
  margin: 0 auto;
  border-radius: 4px;
  background-color: ${LayoutColors.gray};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  ${device.mediumTablet} {
    height: 333px;
  }
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;

  ${device.mediumTablet} {
    gap: 16px;
    padding: 24px;
  }
`;

const Description = styled.div`
  width: 100%;
  max-width: 430px;
  background-color: ${LayoutColors.successLightest};
  border-radius: 4px;
  ${BodyRegularMedium}
  color: ${LayoutColors.successDark};
  padding: 6px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: center;

  ${device.smallTablet} {
    padding: 16px;
    gap: 12px;
  }

  ${device.mediumTablet} {
    ${BodyLargeMedium};
    color: ${LayoutColors.successDark};
    padding: 24px 16px;
  }
`;

const Button = styled.button`
  width: 100%;
  max-width: 430px;
  background-color: ${LayoutColors.successDark};
  border-radius: 4px;
  padding: 10px !important;
  ${BodyRegularSemiBold};
  color: ${LayoutColors.whiteLight};
  cursor: pointer;
  border: none;
  border-style: none;
`;
